module.exports = __webpack_public_path__ + "static/media/menu-transactions.73a566e8.svg";